import React, { useEffect, useState, useContext, forwardRef } from 'react';
import gsap from 'gsap';
import { createPortal } from "react-dom";
import HelpScreen from './HelpScreen';
import CloseButton from './CloseButton';
import { PageContainer } from './Utilities';
import { VideoContext } from '../context/VideoContext';

const HelpModal = forwardRef(({ open, setOpen }, ref) => {
  const { lastEvent } = useContext(VideoContext);
  const [mounted, setMounted] = useState(false);

  const clickCloseButton = () => {
    gsap.to(ref.current, {
      opacity: 0, duration: .75, ease: "power4.out",
      onComplete: () => {
        ref.current.style.display = "hidden";
        ref.current.style.pointerEvents = "none";
      }
    });
    setOpen(false);

    document.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').forEach(el => {
      el.setAttribute('tabindex', null);
    });

    let el = document.querySelector(".helpButton").focus();
    if (el) {
        if (lastEvent === "mousedown") {
            el.focus();
          } else {
              el.contentEditable = true;
              el.focus();
              el.contentEditable = false;
          }
          }
  };

  // slight hack to ensure the component is mounted before trying to create the portal and render the component
  useEffect(() => {
    setMounted(true);
    return () => {
      setMounted(false);
    };
  }, []);

  return (mounted)
    ? createPortal(
        <div
          ref={ref}
          className={`fixed top-0 left-0 w-screen h-screen align-middle justify-center overflow-hidden bg-black bg-opacity-90 z-[10000000000] opacity-0 ${open ? "flex" : "hidden"} pointer-events-none`}
        >
          <PageContainer id="helpScreenModal" className="min-h-screen">
            <HelpScreen modal="true" />
          </PageContainer>

          <button 
            onClick={clickCloseButton}
            className="absolute z-10 top-[4px] right-[20px] cursor-pointer"
          >
            <CloseButton />
          </button>
        </div>,
        document.querySelector("body")
      )
    : null;
});

export default HelpModal;